export { default } from "./DeleteMailingList";



// WEBPACK FOOTER //
// ./src/mutations/DeleteMailingList/index.ts